<span
  [ngClass]="classNames"
  role="img"
  [attr.aria-label]="ariaLabel"
  [attr.aria-hidden]="!ariaLabel"
  class="bb-icon"
></span>
